/* @flow */
/* eslint-env es6,browser */
import _scheduler from './scheduler';

/**
 * Scheduler using requestAnimationFrame(rAF)
 *
 * @class _RAFScheduler
 * @augments _scheduler
 */
export default class _RAFScheduler extends _scheduler<?AnimationFrameID> {
  static isSupported(): boolean {
    return window.requestAnimationFrame !== undefined;
  }

  constructor(n: string) {
    super(n);
    this._tid = null;
  }

  /**
   * Clears pending task
   *
   * @access private
   * @memberof _RAFScheduler
   * @returns {undefined}
   * @override
   */
  _clear() {
    if (this._tid) {
      cancelAnimationFrame(this._tid);
      this._tid = null;
    }
  }

  /**
   *
   * Schedule next RAF
   *
   * @memberof _RAFScheduler
   * @override
   * @access private
   * @returns {undefined}
   */
  _schedule() {
    const that = this;
    this._tid = requestAnimationFrame(() => that._processEntry());
  }
}
